import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import ApiService from '../ApiService'
import { Auth } from '@aws-amplify/auth'
import Snackbar from '@material-ui/core/Snackbar'
import removeClass from '../util/RemoveCSS'
import statesList from '../util/statesList'
import { clinicianIdFromRefreshAuth } from '../util/authUtil'
import cameraIcon from '../assets/camera.svg'
import calIcon from '../assets/cal.svg'
import editIcon from '../assets/edit.svg'
import successIcon from '../assets/success.svg'
import checkIcon from '../assets/check.svg'
import docIcon from '../assets/doc.png'
import profileIcon from '../assets/profile.svg'
import userIcon from '../assets/user.png'
import MuiAlert from '@material-ui/lab/Alert'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const centerThis = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const spaceOut = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}

const Profile_deprecated = props => {
  //$ Page Data
  const [clinicianProfile, setClinicianProfile] = useState([])
  const [licenses, setLicenses] = useState()
  const [roughLics, setRoughLics] = useState()
  const [calendlyLink, setCalendlyLink] = useState('')
  const [profileDetails, setProfileDetails] = useState()
  const [show, setShow] = useState(2)
  const [editLicense, setEditLicense] = useState(false)
  const [loading, setLoading] = useState(true)
  const [validated, setValidated] = useState(false)

  //$ Get Clinician ID from Auth
  const [clinicianId, setClinicianId] = useState(null);

  //$ Modal Data
  const [profileModal, setProfileModal] = useState(false)
  const [snackOpen, setSnackOpen] = useState(false)
  const [snackText, setSnackText] = useState('')
  const [snackSeverity, setSnackSeverity] = useState('')

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity)
    setSnackText(text)
    setSnackOpen(true)
  }

  const handleClose = () => {
    setProfileModal(false)
  }

  const handleSnackClose = () => {
    setSnackOpen(false)
  }

  //& PART 1 : Fetch Clinician Profile from ID
  useEffect(() => {
    ;(async () => {
      setLoading(true)
      try {
        const res = await ApiService.getClinicianProfile(clinicianId)
        setClinicianProfile(res.data)
        let modifyAddedArray =
          res.data.licenses?.length &&
          res.data.licenses.map(lic => {
            lic.modify = false
            return lic
          })
        setLicenses(modifyAddedArray || [])
        setRoughLics(modifyAddedArray || [])
      } catch (error) {
        console.error(error.message)
      } finally {
        setLoading(false)
      }
    })()
  }, [clinicianId])

  //$ Basic Validate Function
  const basicValidation = e => {
    try {
      e.preventDefault()
      const formData = new FormData(e.target),
        formDataObj = Object.fromEntries(formData.entries())
      setProfileDetails({ id: clinicianId, ...formDataObj })
      setProfileModal(true)
    } catch (error) {
      console.error(error.message)
    } finally {
      // Post Submit
    }
  }

  //$ Function to Update Profile
  const updateClinicianProfile = async e => {
    try {
      if (profileDetails) {
        setLoading(true)
        const res = await ApiService.updateClinicianProfile(profileDetails)
        handleSnackOpen('Profile has been updated', 'success')
        handleClose()
      } else {
        handleSnackOpen('Profile Update Failed', 'error')
        handleClose()
      }
    } catch (error) {
      console.error(error.message)
      handleSnackOpen(`Profile Update Failed`, 'error') // for dummy
    } finally {
      setLoading(false)
    }
  }

  //` Clear Form
  const handleClear = e => {
    document.querySelectorAll('input').forEach(input => (input.value = ''))
  }

  removeClass() //` Didnt Removed this dont know purpose of this

  //$ Style Overrides for this page
  useEffect(() => {
    document.body.style.background = 'rgba(253, 250, 241, 1)'
    return () => {
      document.body.style.background = '#FDFAF1'
    }
    clinicianIdFromRefreshAuth().then(id => setClinicianId(id));
  }, [])

  //$ Add Calendar Link
  const processLink = () => {
    async function postCalendarLink() {
      try {
        // const postCalendarLink = await ApiService.postCalendarLink({ link: calendlyLink })
        handleSnackOpen('Calendar Link has been updated', 'success')
      } catch (err) {
        console.error(err)
        handleSnackOpen(`Calendar Link Update Failed`, 'error')
      }
    }
    postCalendarLink()
  }

  //$ Add License To Profile
  const addLicenseToProfile = async licInfo => {
    setLoading(true)
    try {
      if (!licInfo) {
        handleSnackOpen('License Update Failed', 'error')
        handleClose()
        return
      }
      const res = await ApiService.updateClinicianProfile({ ...clinicianProfile, licenses: licInfo })
      handleSnackOpen('License has been added to profile', 'success')
      handleClose()
    } catch (error) {
      console.log(error.message)
      handleSnackOpen(`License Update Failed`, 'error')
    } finally {
      setLoading(false)
    }
  }

  //& Main View
  return (
    <Row className="mt-4">
      {/* //& Loading View */}
      {loading && (
        <Row style={{ background: 'rgba(255,255,255,0.5)', position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, zIndex: 100000 }}>
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Row>
      )}
      {/* //& Main Container */}
      <Col style={{ flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* //$ Left Side View */}
        <p
          style={{
            fontSize: 60,
            lineHeight: '100%',
            color: 'rgba(0, 127, 97, 1)',
            textTransform: 'capitalize',
            fontFamily: 'GT Super Display',
            fontWeight: '500',
          }}
        >
          My Profile
        </p>
        <div style={{ width: '80%', height: '100%', borderRadius: 25, background: 'rgba(0, 127, 97, 1)' }}>
          {/* Avatar Image */}
          <div style={centerThis}>
            <div
              className="mt-5"
              style={{
                width: 150,
                height: 150,
                borderRadius: 500,
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <img style={{ left: 0, top: 0, position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }} src={userIcon} alt="Avatar" />
              {/* <img style={{ position: 'absolute', left: '70%', top: '70%', pointerEvents: 'none' }} src={cameraIcon} alt="change icon" /> */}
            </div>
          </div>
          <p
            style={{ fontSize: 24, fontWeight: '600', letterSpacing: 2, lineHeight: '116.70%', color: 'rgba(253, 250, 241, 1)', marginTop: 15 }}
          >{`${clinicianProfile?.firstName} ${clinicianProfile?.lastName}`}</p>

          <p style={{ textAlign: 'center', fontSize: 16, lineHeight: '116.70%', color: 'rgba(253, 250, 241, 0.50)', textTransform: 'capitalize' }}>APRN - CB</p>
          <Col style={centerThis}>
            <div style={{ textAlign: 'center', width: 155, height: 60 }}>
              <p style={{ cursor: 'pointer', fontSize: 18, fontWeight: '500', lineHeight: '116.70%', color: 'rgba(253, 250, 241, 1)' }}>
                Fun fact about me&nbsp;&nbsp;&nbsp;
                {/* <img src={editIcon} alt="change fun fact" /> */}
              </p>
              <p style={{ fontSize: 16, fontWeight: '600', lineHeight: '50%', color: 'rgba(253, 250, 241, 1)' }}>{clinicianProfile?.funFact || '-'}</p>
            </div>
          </Col>
          <div style={{ width: 305, height: 162, display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <div style={{ height: 4.67 }} />
            <p
              style={{
                cursor: 'pointer',
                opacity: show === 2 ? 1 : 0.6,
                width: '100%',
                fontSize: 28,
                fontWeight: show === 2 ? 'bold' : 'normal',
                lineHeight: '116.70%',
                color: 'rgba(253, 250, 241, 1)',
                textAlign: 'left',
              }}
              onClick={() => setShow(2)}
            >
              <img alt="icon" src={profileIcon} style={{ height: 28, filter: 'invert(1)', objectFit: 'contain' }} />
              &nbsp;&nbsp;Personal Information
            </p>
            <div style={{ height: 4.67 }} />
            <p
              style={{
                cursor: 'pointer',
                width: '100%',
                fontSize: 28,
                fontWeight: show === 3 ? 'bold' : 'normal',
                opacity: show === 3 ? 1 : 0.6,
                lineHeight: '116.70%',
                color: 'rgba(253, 250, 241, 1)',
                textAlign: 'left',
              }}
              onClick={() => setShow(3)}
            >
              <img alt="icon" src={docIcon} style={{ height: 28, filter: 'invert(1)', objectFit: 'contain' }} />
              &nbsp;&nbsp;Manage Licences
            </p>
            <div style={{ height: 4.67 }} />
            <p
              style={{
                cursor: 'pointer',
                width: '100%',
                fontSize: 28,
                fontWeight: show === 4 ? 'bold' : 'normal',
                opacity: show === 4 ? 1 : 0.6,
                lineHeight: '116.70%',
                color: 'rgba(253, 250, 241, 1)',
                textAlign: 'left',
              }}
              onClick={() => setShow(4)}
            >
              <img alt="icon" src={calIcon} style={{ height: 28, filter: 'invert(1)', objectFit: 'contain' }} />
              &nbsp;&nbsp;Manage Calendar
            </p>
          </div>
        </div>
      </Col>

      <Container fluid="xl">
        <Row style={{ height: '75vh' }}>
          {/* //& PROFILE VIEW */}
          {show === 2 && (
            <Col style={{ flex: 2.5 }}>
              <Form id="newForm" style={{ height: '100%' }} onSubmit={basicValidation}>
                <Col style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingBottom: 30 }}>
                  <p
                    style={{
                      fontSize: 28,
                      color: 'rgba(0, 127, 97, 1)',
                      textTransform: 'capitalize',
                      fontFamily: 'GT Super Display',
                      fontWeight: '500',
                      marginTop: 60,
                      width: '100%',
                      textAlign: 'left',
                    }}
                  >
                    General Details
                  </p>
                  <Row style={spaceOut}>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="firstName">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control defaultValue={clinicianProfile?.firstName || null} required name="firstName" type="text" placeholder="First Name" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="middleName">
                        <label>Middle Name</label>
                        <Form.Control defaultValue={clinicianProfile?.middleName || ''} name="middleName" placeholder="Middle Name" type="text" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="lastName">
                        <label>Last Name</label>
                        <Form.Control defaultValue={clinicianProfile?.lastName || null} required name="lastName" placeholder="Last Name" type="text" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={spaceOut}>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="dob">
                        <label>Date of Birth</label>
                        <Form.Control defaultValue={clinicianProfile?.dob || null} required name="dob" placeholder="DOB" type="date" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="genderAtBirth">
                        <label>Sex assigned at birth</label>
                        <Form.Select defaultValue={clinicianProfile?.genderAtBirth || null} required name="genderAtBirth" style={{ width: '100%' }} id="formSelect">
                          <option disabled selected value="">
                            Select Sex at Birth
                          </option>
                          <option value={'Male'}>Male</option>
                          <option value={'Female'}>Female</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="v">
                        <label>Fun Fact</label>
                        <Form.Control defaultValue={clinicianProfile?.funFact || null} name="funFact" as={'textarea'} placeholder="Fun Facts" type="text" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <p
                    style={{
                      fontSize: 28,
                      color: 'rgba(0, 127, 97, 1)',
                      textTransform: 'capitalize',
                      fontFamily: 'GT Super Display',
                      fontWeight: '500',
                      width: '100%',
                      textAlign: 'left',
                    }}
                  >
                    Contact Details
                  </p>
                  <Row style={spaceOut}>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="personalEmail">
                        <label>Personal Email</label>
                        <Form.Control defaultValue={clinicianProfile?.personalEmail || null} required name="personalEmail" placeholder="Personal Email" type="email" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="address1">
                        <label>Address Line 1</label>
                        <Form.Control defaultValue={clinicianProfile?.address1 || null} required name="address1" placeholder="Address Line 1" type="text" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="address2">
                        <label>Address Line 2</label>
                        <Form.Control defaultValue={clinicianProfile?.address2 || null} required name="address2" placeholder="Address Line 2" type="text" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={spaceOut}>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="city">
                        <label>City</label>
                        <Form.Control defaultValue={clinicianProfile?.city || null} required name="city" placeholder="City" type="text" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="state">
                        <label>State</label>
                        <Form.Select defaultValue={clinicianProfile?.state || null} required name="state" id="formSelect">
                          <option disabled selected value="">
                            Select State
                          </option>
                          {statesList?.map(item => (
                            <option value={item.value}>{item.label}</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="zip">
                        <label>Zip Code</label>
                        <Form.Control defaultValue={clinicianProfile?.zip || null} required name="zip" placeholder="Zip Code" type="text" />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={spaceOut}>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="hobbies">
                        <label>hobbies</label>
                        <Form.Control defaultValue={clinicianProfile?.hobbies || null} name="hobbies" as={'textarea'} placeholder="hobbies" type="text" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="emergencyContactName">
                        <label>Emergency Contact Name</label>
                        <Form.Control defaultValue={clinicianProfile?.emergencyContactName || null} required name="emergencyContactName" placeholder="Name" type="text" />
                      </Form.Group>
                    </Col>
                    <Col md="3">
                      <Form.Group className="mb-3" controlId="emergencyContactPhone">
                        <label>Emergency Contact Number</label>
                        <Form.Control
                          defaultValue={clinicianProfile?.emergencyContactPhone || null}
                          required
                          name="emergencyContactPhone"
                          placeholder="Phone"
                          type="text"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                    <Button
                      variant="light"
                      style={{
                        width: 180,
                        height: 40,
                        borderRadius: 8,
                        backgroundColor: 'rgba(253, 250, 241, 1)',
                        fontSize: 20,
                        fontWeight: '500',
                        lineHeight: '100%',
                        border: 'none',
                        color: 'rgba(0, 127, 97, 1)',
                      }}
                      onClick={handleClear}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="light"
                      type="submit"
                      style={{
                        width: 180,
                        height: 40,
                        marginLeft: 20,
                        borderRadius: 8,
                        backgroundColor: 'rgba(0, 127, 97, 1)',
                        fontSize: 20,
                        fontWeight: '500',
                        lineHeight: '100%',
                        color: 'rgba(253, 250, 241, 1)',
                        border: 'none',
                      }}
                    >
                      Update
                    </Button>
                  </Row>
                </Col>
              </Form>
            </Col>
          )}

          {/* //& Licenses View */}
          {show === 3 && (
            <Col style={{ flex: 2.5 }}>
              <Row style={spaceOut}>
                <div
                  style={{
                    fontSize: 28,
                    color: 'rgba(0, 127, 97, 1)',
                    textTransform: 'capitalize',
                    fontFamily: 'GT Super Display',
                    fontWeight: '500',
                    marginTop: 60,
                  }}
                >
                  Manage Licenses
                </div>
                {!editLicense ? (
                  <Button
                    variant="light"
                    onClick={() => {
                      setEditLicense(true)
                    }}
                    style={{
                      width: 180,
                      height: 40,
                      marginLeft: 20,
                      borderRadius: 8,
                      backgroundColor: 'rgba(0, 127, 97, 1)',
                      fontSize: 20,
                      fontWeight: '600',
                      lineHeight: '100%',
                      color: 'rgba(253, 250, 241, 1)',
                      border: 'none',
                      marginRight: 40,
                      letterSpacing: 1.5,
                    }}
                  >
                    <img alt="" src={editIcon} style={{ objectFit: 'contain', height: 15 }} />
                    &nbsp;&nbsp;Edit License
                  </Button>
                ) : (
                  <Row>
                    <Button
                      variant="light"
                      onClick={() => {
                        setRoughLics(licenses)
                        setEditLicense(false)
                      }}
                      style={{
                        width: 'auto',
                        paddingInline: 20,
                        height: 40,
                        marginLeft: 20,
                        borderRadius: 8,
                        backgroundColor: 'red',
                        fontSize: 20,
                        fontWeight: '600',
                        lineHeight: '100%',
                        color: 'rgba(253, 250, 241, 1)',
                        border: 'none',
                        marginRight: 40,
                        letterSpacing: 1.5,
                      }}
                    >
                      X &nbsp;&nbsp;Discard
                    </Button>
                    <Button
                      variant="light"
                      onClick={async () => {
                        const lastItem = roughLics?.length ? roughLics[roughLics.length - 1] : null
                        if (!lastItem || lastItem.state === '' || lastItem.licenseNumber === '' || lastItem.expirationDate === '' || lastItem.isGoodStanding === '') {
                          handleSnackOpen('Please fill out all fields before saving or discard', 'error')
                          return
                        }
                        let tmpArray = roughLics.map(obj => {
                          let { modify, ...rest } = obj
                          return rest
                        })
                        await addLicenseToProfile(tmpArray)
                        setLicenses(roughLics)
                        setEditLicense(false)
                      }}
                      style={{
                        width: 'auto',
                        height: 40,
                        marginLeft: 20,
                        borderRadius: 8,
                        backgroundColor: 'rgba(0, 127, 97, 1)',
                        fontSize: 20,
                        fontWeight: '600',
                        lineHeight: '100%',
                        color: 'rgba(253, 250, 241, 1)',
                        border: 'none',
                        marginRight: 40,
                        letterSpacing: 1.5,
                      }}
                    >
                      <img alt="done" src={checkIcon} style={{ height: 18, filter: 'invert(1)', objectFit: 'contain' }} />
                      &nbsp;&nbsp;Done
                    </Button>
                  </Row>
                )}
              </Row>
              <Table borderless>
                <tr style={{ background: 'transparent' }} className="TableHeaderRow">
                  <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
                    State
                  </td>
                  <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
                    License Number
                  </td>
                  <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
                    Expiration
                  </td>
                  <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd">
                    In Good Standing
                  </td>
                  <td style={{ opacity: 0.6, fontWeight: '600', letterSpacing: 1.5 }} className="HeaderTd"></td>
                </tr>



                {!editLicense &&
                  licenses?.map(license => (
                    <tr style={{ background: 'transparent' }} className="TableRow">
                      <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                        {license.state}
                      </td>
                      <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                        {license.licenseNumber}
                      </td>
                      <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                        {license.expirationDate}
                      </td>
                      <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                        {license.isGoodStanding ? 'Yes' : 'No'}
                      </td>
                      <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                        <img src={successIcon} alt="success" />
                      </td>
                    </tr>
                  ))}
                {editLicense &&
                  roughLics?.map((license, ind) => {
                    return !license.modify ? (
                      <tr style={{ background: 'transparent' }} className="TableRow">
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          {license.state}
                        </td>
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          {license.licenseNumber}
                        </td>
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          {license.expirationDate}
                        </td>
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          {license.isGoodStanding ? 'Yes' : 'No'}
                        </td>
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          <Button
                            variant="dark"
                            onClick={() => {
                              const temp = [...licenses]
                              temp[ind].modify = true
                              setLicenses(temp)
                            }}
                            style={{
                              width: 'auto',
                              height: 'auto',
                              borderRadius: 8,
                              border: 'none',
                            }}
                          >
                            <img alt="done" src={editIcon} style={{ height: 12, objectFit: 'contain' }} />
                          </Button>
                        </td>
                      </tr>
                    ) : (
                      <tr style={{ background: 'transparent' }} className="TableRow">
                        <td>
                          <Form.Group controlId="licenseNumber">
                            <Form.Select
                              defaultValue={license.state}
                              onChange={e => {
                                const temp = [...roughLics]
                                temp[ind].state = e.target.value
                                setRoughLics(temp)
                              }}
                              className="form-control"
                              required
                              name="state"
                            >
                              <option disabled selected value="">
                                Select State
                              </option>
                              {statesList?.map(item => (
                                <option value={item.value}>{item.value}</option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </td>
                        <td>
                          <Form.Group controlId="licenseNumber">
                            <Form.Control
                              defaultValue={license.licenseNumber}
                              onChange={e => {
                                const temp = [...roughLics]
                                temp[ind].licenseNumber = e.target.value
                                setRoughLics(temp)
                              }}
                              required
                              name="licenseNumber"
                              placeholder="Enter License No"
                              type="text"
                            />
                          </Form.Group>
                        </td>
                        <td>
                          <Form.Group controlId="expirationDate">
                            <Form.Control
                              defaultValue={license.expirationDate}
                              onChange={e => {
                                const temp = [...roughLics]
                                temp[ind].expirationDate = e.target.value
                                setRoughLics(temp)
                              }}
                              required
                              name="expirationDate"
                              placeholder="Date"
                              type="date"
                            />
                          </Form.Group>
                        </td>
                        <td>
                          <Form.Group controlId="licenseNumber">
                            <Form.Select
                              defaultValue={license.isGoodStanding}
                              onChange={e => {
                                const temp = [...roughLics]
                                temp[ind].isGoodStanding = e.target.value === 'true' ? true : false
                                setRoughLics(temp)
                              }}
                              className="form-control"
                              required
                              name="isGoodStanding"
                              id="isGoodStanding"
                            >
                              <option disabled selected value="">
                                Good Standing
                              </option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </Form.Select>
                          </Form.Group>
                        </td>
                        <td style={{ opacity: 1, fontWeight: 'normal', letterSpacing: 1.5 }} className="Td">
                          <Button
                            variant="light"
                            onClick={() => {
                              const temp = [...roughLics]
                              const lastItem = temp[ind]
                              if (lastItem.state === '' || lastItem.licenseNumber === '' || lastItem.expirationDate === '' || lastItem.isGoodStanding === '') {
                                handleSnackOpen('Please fill out all fields before confirmation', 'error')
                                return
                              }
                              temp[ind].modify = false
                              setRoughLics(temp)
                            }}
                            style={{
                              width: 'auto',
                              height: 'auto',
                              borderRadius: 8,
                              backgroundColor: 'rgba(0, 127, 97, 1)',
                              color: 'rgba(253, 250, 241, 1)',
                              border: 'none',
                            }}
                          >
                            <img alt="done" src={checkIcon} style={{ height: 12, objectFit: 'contain', filter: 'invert(1)' }} />
                            &nbsp;&nbsp;Confirm
                          </Button>
                        </td>
                      </tr>
                    )
                  })}
                {editLicense && (
                  <tr style={{ background: 'transparent' }}>
                    <td></td>
                    <td></td>
                    <td>
                      <Button
                        variant="light"
                        onClick={() => {
                          roughLics?.length
                            ? setRoughLics([...roughLics, { state: '', licenseNumber: '', expirationDate: '', isGoodStanding: '', modify: true }])
                            : setRoughLics([{ state: '', licenseNumber: '', expirationDate: '', isGoodStanding: '', modify: true }])
                        }}
                        style={{
                          width: 'auto',
                          height: 'auto',
                          borderRadius: 8,
                          backgroundColor: 'rgba(0, 127, 97, 1)',
                          color: 'rgba(253, 250, 241, 1)',
                          border: 'none',
                        }}
                      >
                        <img alt="done" src={checkIcon} style={{ height: 12, objectFit: 'contain', filter: 'invert(1)' }} />
                        &nbsp;&nbsp;Add New License
                      </Button>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                )}
              </Table>
            </Col>
          )}

          {/* //& CALENDLY VIEW */}
          {show === 4 && (
            <Col style={{ flex: 2.25 }}>
              <Row style={spaceOut}>
                <div
                  style={{
                    fontSize: 28,
                    color: 'rgba(0, 127, 97, 1)',
                    textTransform: 'capitalize',
                    fontFamily: 'GT Super Display',
                    fontWeight: '500',
                    marginTop: 60,
                  }}
                >
                  Manage Calendar Link
                </div>
              </Row>
              <Row style={spaceOut}>
                <Form.Group className="mb-3 mt-3" controlId="calendlyLink">
                  <Form.Label>Calendar Link</Form.Label>
                  <Form.Control type="text" placeholder="Enter Calender Link" onChange={e => setCalendlyLink(e.target.value)} />
                </Form.Group>
                <Button
                  variant="light"
                  onClick={processLink}
                  style={{
                    width: 180,
                    height: 40,
                    marginLeft: 20,
                    borderRadius: 8,
                    backgroundColor: 'rgba(0, 127, 97, 1)',
                    fontSize: 20,
                    fontWeight: '600',
                    lineHeight: '100%',
                    color: 'rgba(253, 250, 241, 1)',
                    border: 'none',
                    marginRight: 40,
                    letterSpacing: 1.5,
                  }}
                >
                  + Add Link
                </Button>
              </Row>
            </Col>
          )}
        </Row>
        {/* //& Confirmation Modal */}
        <Modal show={profileModal} onHide={() => handleClose()} backdrop={'static'}>
          <Modal.Header>
            <Modal.Title>Confirm Profile Updates</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure want to update the profile details ?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="light" style={{ color: 'white', background: 'rgba(0, 127, 97, 1)' }} onClick={updateClinicianProfile}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </Row>
  )
}

export default Profile_deprecated
